import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=051721cb&scoped=true&"
import script from "./ModalAlert.vue?vue&type=script&lang=js&"
export * from "./ModalAlert.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlert.vue?vue&type=style&index=0&id=051721cb&prod&rel=stylesheet&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051721cb",
  null
  
)

export default component.exports